var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(tag){return _c('app-chip',{key:tag,staticClass:"my-1",attrs:{"title":tag,"hashtag":"#","small":"","to":{ name: 'Tags', params: { tag: tag } }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }